<template>
<div id="frame">
    <card :title="title" :subTitle="subtitle" v-if="tick === 1" id="frame">
       
        <form>
            <v-text-field
                v-model="date"
                :error-messages="dateErrors"
                label="Datum"
                @input="$v.date.$touch()"
                @blur="$v.date.$touch()"
                type="date"
                required
            ></v-text-field>
            <v-select
                v-model="selectedMessstelle"
                :items="messstellen.bereich[$route.params.bereich-1]"
                item-text="selectText"
                item-value="messstelle"
                :label="messstellenLabel"
                return-object
                attach
                required
            >
            </v-select>
         
            <v-text-field
                v-model="name"
                :error-messages="nameErrors"
                label="Ihr Name"
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
                required
                clearable
                @click:clear="clearName()"
            ></v-text-field>
            <v-text-field
                v-model="temperatur"
                :error-messages="temperaturErrors"
                label="Temperatur"
                type="number"
                step="0.1"
                :disabled="!active"
                @input="$v.temperatur.$touch()"
                @blur="$v.temperatur.$touch()"
                :required="active"
            ></v-text-field>
            <v-text-field
                v-model="bemerkung"
                :label="bemerkungLabel"
                required
                v-on:keyup.enter="nextTick()"
            ></v-text-field>
            <v-switch v-model="active" :label="switchlbl" color="red"></v-switch>
           <v-divider/>
            <!-- <v-btn @click="submit">submit</v-btn> -->
            <button class="btn btn-lg btn-danger float-left" v-on:click="goBack('cancelAdd')" type="button">abbrechen</button>  
            <button class="btn btn-lg btn-success float-right" v-on:click="nextTick()" type="button">bestätigen</button>
        </form>
    </card>

    <card :title="title2" v-if="tick === 2" id="frame">
        <hr>
        <!-- bestätigen --> 
        <div class="angaben">
            <p class="messstelle">{{title}}</p>
            <p>Datum: {{formatDate(date)}}</p>
            <p>Messstelle: {{selectedMessstelle.selectText}}</p>
            <p>Ihr Name: {{name}}</p>
            <p> Temperatur: {{temperatur}}°C</p>
            <p>Bemerkung: {{bemerkung}}</p>
        </div>
        <hr>
        <!-- unterschrift -->
        <div class="signature">  
            <VueSignaturePad
                width="100%"
                height="200px"
                ref="signaturePad"
                saveType="image/png"
                class="pad"
            />
            <p class="instruction">Bitte hier unterschreiben!</p>
        </div>
        <button class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button>    
        <button class="btn btn-lg btn-success float-right" v-on:click="save()" type="button">bestätigen</button>
    </card>

    <div class="alert alert-success" v-if="tick === 3" id="alert">
        <!-- Erfoglsmeldung -->
        <button type="button" aria-hidden="true" class="close"></button>
        <span>
        <b>Erfolgreich erstellt! - </b> Ein entsprechender Eintrag wurde vorgenommen!</span>
    </div>
    <div class="alert alert-danger" v-if="showErrorMessage && tick === 4">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
      <span>
        <b>Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut</b>
      </span>
    </div>  
</div>
</template>

<script>
import { validationMixin } from "vuelidate"
import { numeric, required, alphaNum } from "vuelidate/lib/validators"
import { helpers } from "vuelidate/lib/validators"

export const alphaDiacritic = helpers.regex("alphaDiacritic", /^[a-zA-ZÀ-ž ]*$/)

export default {
    mixins: [validationMixin],

    validations: {
        name: { required, alphaDiacritic },
        temperatur: { required },
        date: { required }
    },
    data() {
        return {
            active: true,
            switchlbl: "Messstelle aktiv",
            routeBack: [],
            tick: 1,
            title: "Neuen Temperatur-Log erstellen",
            subtitle: "Bereich ",
            title2: "Angaben bestätigen und unterzeichnen",
            temperatur: "",
            date: "",
            name: "",
            signature: "",
            bemerkung: "",
            showErrorMessage: false,
            selectedMessstelle: {},
            messstellenLabel: "Messstelle",
            bemerkungLabel: "Bemerkung",
            messstellen: {
                bereich: [
                    [
                        { stelle: 1, messstelle: 1, title: "Kühlhaus Fleisch", selectText: "1 | Kühlhaus Fleisch | 0,5°C", maxTemp: 0.5 },
                        { stelle: 2, messstelle: 10, title: "Fleisch-SB", selectText: "2 | Fleisch-SB | 2°C", maxTemp: 2 },
                        { stelle: 3, messstelle: 2, title: "Fleischtheke", selectText: "3 | Fleischtheke | 3°C", maxTemp: 3 },
                        { stelle: 4, messstelle: 3, title: "Geflügel-Theke", selectText: "4 | Geflügel-Theke | 1°C", maxTemp: 1 },
                        { stelle: 5, messstelle: 4, title: "Kühlhaus Wurst", selectText: "5 | Kühlhaus Wurst | 7°C", maxTemp: 7 },
                        { stelle: 6, messstelle: 5, title: "Wursttheke", selectText: "6 | Wursttheke | 7°C", maxTemp: 7 },
                        { stelle: 7, messstelle: 6, title: "Kühlschublade", selectText: "7 | Kühlschublade | 7°C", maxTemp: 7 },
                        { stelle: 8, messstelle: 7, title: "Käsetheke", selectText: "8 | Käsetheke | 7°C", maxTemp: 7 },
                        { stelle: 9, messstelle: 8, title: "Käse-Kühlschrank", selectText: "9 | Käse-Kühlschrank | 7°C", maxTemp: 7 },
                        { stelle: 10, messstelle: 9, title: "Käse-SB Truhe", selectText: "10 | Käse-SB Truhe | 7°C", maxTemp: 7 }
                    ],
                    [
                        { stelle: 1, messstelle: 1, title: "Kühlhaus", selectText: "1 | Kühlhaus | 7°C", maxTemp: 7 },
                        { stelle: 2, messstelle: 2, title: "Wurst-SB", selectText: "2 | Wurst-SB | 7°C", maxTemp: 7 },
                        { stelle: 3, messstelle: 19, title: "Grillwurst", selectText: "3 | Grillwurst | 7°C", maxTemp: 7 },
                        { stelle: 4, messstelle: 3, title: "Fisch-SB", selectText: "4 | Fisch-SB | 7°C", maxTemp: 7 },
                        { stelle: 5, messstelle: 4, title: "Salat/Rüma", selectText: "5 | Salat/Rüma | 7°C", maxTemp: 7 },
                        { stelle: 6, messstelle: 5, title: "Margarine+Butter", selectText: "6 | Margarine+Butter | 7°C", maxTemp: 7 },
                        { stelle: 7, messstelle: 6, title: "Käse-SB", selectText: "7 | Käse-SB | 7°C", maxTemp: 7 },
                        { stelle: 8, messstelle: 7, title: "Frischkäse-SB", selectText: "8 | Frischkäse-SB | 7°C", maxTemp: 7 },
                        { stelle: 9, messstelle: 8, title: "MoPro Block 1", selectText: "9 | MoPro Block 1 | 7°C", maxTemp: 7 },
                        { stelle: 10, messstelle: 9, title: "MoPro Block 2", selectText: "10 | MoPro Block 2 | 7°C", maxTemp: 7 },
                        { stelle: 11, messstelle: 10, title: "MoPro Pudding", selectText: "11 | MoPro Pudding | 7°C", maxTemp: 7 },
                        { stelle: 12, messstelle: 11, title: "SB-Truhe hinten", selectText: "12 | SB-Truhe hinten | 7°C", maxTemp: 7 },
                        { stelle: 13, messstelle: 12, title: "Veggie-Schrank 1", selectText: "13 | Veggie-Schrank 1 | 7°C", maxTemp: 7 },
                        { stelle: 14, messstelle: 13, title: "Veggie-Schrank 2", selectText: "14 | Veggie-Schrank 2 | 7°C", maxTemp: 7 },
                        { stelle: 15, messstelle: 14, title: "Veggie-Schrank 3", selectText: "15 | Veggie-Schrank 3 | 7°C", maxTemp: 7 },
                        { stelle: 16, messstelle: 15, title: "Veggie-Schrank 4", selectText: "16 | Veggie-Schrank 4 | 7°C", maxTemp: 7 },
                        { stelle: 17, messstelle: 16, title: "Salate/Frischnudeln", selectText: "17 | Salate/Frischnudeln | 7°C", maxTemp: 7 },
                        { stelle: 18, messstelle: 17, title: "Convenience-Truhe 1", selectText: "18 | Convenience-Truhe 1 | 7°C", maxTemp: 7 },
                        { stelle: 19, messstelle: 18, title: "Convenience-Truhe 2", selectText: "19 | Convenience-Truhe 2 | 7°C", maxTemp: 7 }
                    ],
                    [
                        { stelle: 1, messstelle: 1, title: "Tiefkühlhaus", selectText: "1 | Tiefkühlhaus | -17°C", maxTemp: -17 },
                        { stelle: 2, messstelle: 2, title: "Brötchentruhe", selectText: "2 | Brötchentruhe | -17°C", maxTemp: -17 },
                        { stelle: 3, messstelle: 3, title: "Iglo-Gemüse", selectText: "3 | Iglo-Gemüse | -17°C", maxTemp: -17 },
                        { stelle: 4, messstelle: 4, title: "Fertiggerichte", selectText: "4 | Fertiggerichte | -17°C", maxTemp: -17 },
                        { stelle: 5, messstelle: 5, title: "Deutsche See", selectText: "5 | Deutsche See | -17°C", maxTemp: -17 },
                        { stelle: 6, messstelle: 6, title: "Fischschrank", selectText: "6 | Fischschrank | -17°C", maxTemp: -17 },
                        { stelle: 7, messstelle: 7, title: "Kuchen-Schrank", selectText: "7 | Kuchen Schrank | -17°C", maxTemp: -17 },
                        { stelle: 8, messstelle: 8, title: "Gemüse links", selectText: "8 | Gemüse links | -17°C", maxTemp: -17 },
                        { stelle: 9, messstelle: 9, title: "Gemüse rechts", selectText: "9 | Gemüse rechts | -17°C", maxTemp: -17 },
                        { stelle: 10, messstelle: 10, title: "Geflügel", selectText: "10 | Geflügel | -17°C", maxTemp: -17 },
                        { stelle: 11, messstelle: 11, title: "Pommes", selectText: "11 | Pommes | -17°C", maxTemp: -17 },
                        { stelle: 12, messstelle: 12, title: "Pizza links", selectText: "12 | Pizza links | -17°C", maxTemp: -17 },
                        { stelle: 13, messstelle: 13, title: "Pizza rechts", selectText: "13 | Pizza rechts | -17°C", maxTemp: -17 },
                        { stelle: 14, messstelle: 14, title: "Eis links", selectText: "14 | Eis links | -17°C", maxTemp: -17 },
                        { stelle: 15, messstelle: 15, title: "Eis rechts", selectText: "15 | Eis rechts | -17°C", maxTemp: -17 },
                        { stelle: 16, messstelle: 18, title: "Florida Eistruhe", selectText: "16 | Florida Eistruhe| -17°C", maxTemp: -17 },
                        { stelle: 17, messstelle: 16, title: "Kleineistruhe", selectText: "17 | Kleineistruhe | -17°C", maxTemp: -17 },
                        { stelle: 18, messstelle: 17, title: "Ben & Jerrys", selectText: "18 | Ben & Jerrys | -17°C", maxTemp: -17 }
                    ],
                    [
                        { stelle: 1, messstelle: 1, title: "Kühlhaus", selectText: "1 | Kühlhaus | 6°C", maxTemp: 6 },
                        { stelle: 2, messstelle: 2, title: "Stolpertruhe", selectText: "2 | Stolpertruhe | 6°C", maxTemp: 6 }
                    ],
                    [
                        { stelle: 1, messstelle: 1, title: "Deutsche See", selectText: "1 | Deutsche See | 20°", maxTemp: 20 },
                        { stelle: 2, messstelle: 2, title: "Rewe Tiefkühl", selectText: "2 | Rewe Tiefkühl | 20°", maxTemp: 20 },
                        { stelle: 3, messstelle: 3, title: "BUBI", selectText: "3 | BUBI | 20°", maxTemp: 20 },
                        { stelle: 4, messstelle: 4, title: "Rewe Frischdienst", selectText: "4 | Rewe Frischdienst | 20°", maxTemp: 20 },
                        { stelle: 5, messstelle: 5, title: "RÜMA", selectText: "5 | RÜMA | 20°", maxTemp: 20 }
                    ],
                    [
                        { stelle: 1, messstelle: 1, title: "Kühlung", selectText: "1 | Kühlung | 5°", maxTemp: 5 },
                        { stelle: 2, messstelle: 2, title: "Tiefkühl", selectText: "2 | Tiefkühl | -18°", maxTemp: -18 }
                    ]
                ]
            },
            mpoints: []
        }
    },

    //mpoints = measuringpoints
    mounted() {
        if (localStorage.getItem("mpoints" + this.$route.params.bereich)) {
            try {
                this.mpoints = JSON.parse(localStorage.getItem("mpoints" + this.$route.params.bereich))
                console.log(this.mpoints)
                // console.log(this.messstellen.bereich[this.$route.params.bereich-1][this.mpoints[0].messstelle])
                if (this.messstellen.bereich[this.$route.params.bereich - 1][this.mpoints[0].messstelle]) {
                    this.selectedMessstelle = this.messstellen.bereich[this.$route.params.bereich - 1][this.mpoints[0].messstelle]
                }
            } catch (e) {
                localStorage.removeItem("mpoints" + this.$route.params.bereich)
            }
        } else {
            this.selectedMessstelle = this.messstellen.bereich[this.$route.params.bereich - 1][0]
        }
        if (localStorage.getItem("name")) {
            try {
                this.name = JSON.parse(localStorage.getItem("name"))
                // console.log(this.mpoints)
            } catch (e) {
                localStorage.removeItem("name")
            }
        }
    },
    watch: {
        active(val) {
            if (val === true) {
                this.switchlbl = "Messstelle aktiv"
                this.bemerkung = ""
                this.temperatur = ""
            } else {
                this.switchlbl = "Messstelle inaktiv"
                this.bemerkung = "Messstelle inaktiv"
                this.temperatur = "- "
            }
        }
    },
    methods: {
        clearName() {
            localStorage.removeItem("name")
            this.name = ""
        },
        saveName() {
            const parsed = JSON.stringify(this.name)
            localStorage.setItem("name", parsed)
        },
        removeMpoint(x) {
            this.mpoints.splice(x, 1)
            this.saveMpoints()
        },
        saveMpoints() {
            const parsed = JSON.stringify(this.mpoints)
            localStorage.setItem("mpoints" + this.$route.params.bereich, parsed)
        },

        disableNotification() {
            this.showErrorMessage = false
        },
        fetchBereich() {
            //bereichsnmame & nummer aus db abrufendann title und subtitle belegen
            console.log(this.$route.params.bereich)
            this.subtitle += this.$route.params.bereich
        },
        nextTick() {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                if (this.active) {
                    if (!_.isEmpty(this.selectedMessstelle) && (+this.temperatur <= this.selectedMessstelle.maxTemp || !_.isEmpty(this.bemerkung))) {
                        this.bemerkungLabel = "Bemerkung"
                        this.messstellenLabel = "Messstelle"
                        this.tick = this.tick + 1
                    } else {
                        // alert("Bitte Messstelle auswählen!")
                        this.messstellenLabel = "Bitte Messstelle auswählen!"
                        if (+this.temperatur > this.selectedMessstelle.maxTemp) {
                            this.bemerkungLabel = "Temp. erhöht! Bitte Bemerkung hinterlegen!"
                        }
                    }
                } else {
                    this.bemerkungLabel = "Bemerkung"
                    this.messstellenLabel = "Messstelle"
                    this.tick++
                }
            }
        },
        cancel() {
            this.tick = 1
        },
        goBack(index) {
            if (index < 0) {
                this.$router.go(index)
            } else if (index === "cancelAdd") {
                this.$router.go(-1)
            }
        },
        formatDate(date) {
            var today = new Date(date)
            var dd = String(today.getDate()).padStart(2, "0")
            var mm = String(today.getMonth() + 1).padStart(2, "0") //January is 0!
            var yyyy = today.getFullYear()
            var date = dd + "." + mm + "." + yyyy
            return date
        },
        createToday() {
            var today = new Date()
            var dd = String(today.getDate()).padStart(2, "0")
            var mm = String(today.getMonth() + 1).padStart(2, "0") //January is 0!
            var yyyy = today.getFullYear()
            var date = yyyy + "-" + mm + "-" + dd
            this.date = date
        },
        save() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
            if (!isEmpty) {
                this.signature = data
                this.nextTick()

                let tempLog = {
                    messstelle: this.selectedMessstelle.messstelle,
                    datum: this.date,
                    temperatur: this.temperatur,
                    pruefer: this.name,
                    unterschrift: this.signature,
                    bemerkung: this.bemerkung,
                    bereich: this.$route.params.bereich,
                    stelle: this.selectedMessstelle.stelle
                }
                this.mpoints.unshift(tempLog)
                this.saveMpoints()
                this.saveName()
                if (this.$route.params.bereich == "5") {
                    setTimeout(() => this.$router.push({ path: "/qs/temperaturen/" + this.$route.params.bereich + "?title=" + this.$route.query.title, query: { routeBack: this.routeBack } }), 1500)
                } else {
                    if (this.messstellen.bereich[this.$route.params.bereich - 1][this.mpoints[0].stelle]) {
                        setTimeout(() => {
                            this.temperatur = ""
                            this.signature = ""
                            this.bemerkung = ""
                            this.tick = 1
                            this.active = true
                            this.selectedMessstelle = this.messstellen.bereich[this.$route.params.bereich - 1][this.mpoints[0].stelle]
                        }, 1500)
                    } else {
                        setTimeout(
                            () => this.$router.push({ path: "/qs/temperaturen/" + this.$route.params.bereich + "?title=" + this.$route.query.title, query: { routeBack: this.routeBack } }),
                            1500
                        )
                    }
                }
                // setTimeout(() => this.$router.push({path: "/temperaturen/"+this.$route.params.bereich+ '?title='+ this.$route.query.title }), 1500);

                // Alter Weg: nach jedem Eintrag ein DB-Eintrag
                // this.$http.post("https://katsios-kesting.de:444/uhltest/heimspiel/templogs/add", tempLog)
                // .then(function(response) {
                //     if(response.body.error){
                //         console.log("error");
                //         this.nextTick();
                //         this.showErrorMessage = true;
                //         setTimeout(() => this.$router.push({path: "/temperaturen/"+this.$route.params.bereich+ '?title='+ this.$route.query.title }), 2500);
                //     } else {
                //         setTimeout(() => this.$router.push({path: "/temperaturen/"+this.$route.params.bereich+ '?title='+ this.$route.query.title }), 2500);
                //     }

                // });
            }
        }
    },
    computed: {
        nameErrors() {
            const errors = []
            if (!this.$v.name.$dirty) return errors
            !this.$v.name.required && errors.push("Bitte geben Sie Ihren Namen ein")
            !this.$v.name.alphaDiacritic && errors.push("Bitte keine Sonderzeichen eingeben")

            return errors
        },
        temperaturErrors() {
            const errors = []
            if (this.active) {
                if (!this.$v.temperatur.$dirty) return errors
                !this.$v.temperatur.required && errors.push("Temperatur muss angegeben werden")
                return errors
            } else {
                return errors
            }
        },
        dateErrors() {
            const errors = []
            if (!this.$v.date.$dirty) return errors
            !this.$v.date.required && errors.push("Bitte wählen Sie ein Datum aus")
            return errors
        }
    },
    created: function() {
        this.routeBack = this.$route.query.routeBack
        this.fetchBereich()
        if (this.$route.query) {
            this.subtitle += " - " + this.$route.query.title
        }
        this.createToday()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#frame {
    margin-left: 0%;
    margin-top: 0%;
    padding-left: 0%;
    padding-top: 0%;
    padding-right: 0%;
}
.v-messages__message {
    color: rgb(255, 115, 0);
}
.instruction {
    text-align: center;
    font-weight: bold;
}
.pad {
    border: 2px solid rgb(117, 108, 108);
    border-radius: 5px;
}
.messstelle {
    font-weight: bold;
    font-size: large;
}
.angaben {
    font-size: large;
    font-weight: bold;
}
</style>
